<template>
    <v-row>
        <v-app-bar
            app
            dense
            fixed
            elevate-on-scroll
            style="border-bottom: 1px solid #ddd; padding: 0px"
            elevation="0"
        >
            <v-btn :to="{ name: 'products' }" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Visualização</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items> </v-toolbar-items>
            <!--</v-toolbar-->
        </v-app-bar>

        <modalmessage ref="modal" />
        <v-col offset="0" cols="12" v-if="product">
            <v-row>
                <v-col cols="8" sm="12" md="12" lg="8">
                    <v-row>
                        <h2>{{ product.name }}</h2>
                        <v-list class="pl-0 body-2">
                            <v-list-item class="pl-0">
                                <span class="subtitle-2"
                                    >Artista Principal:</span
                                >
                                {{ product.artist.name }}
                            </v-list-item>
                            <v-list-item class="pl-0">
                                <span class="subtitle-2"
                                    >Data de lançamento:</span
                                >
                                {{
                                    product.release_date
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                }}
                            </v-list-item>
                        </v-list>
                    </v-row>
                </v-col>
                <v-col cols="4" sm="12" md="12" lg="4" v-if="computed_cover" justify="center" align-self="start">
                    <v-img height="200px" contain :src="computed_cover"></v-img>
                </v-col>
            </v-row>
            
             <h2>Faixas</h2>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Ordem</th>
                            <th class="text-left">Nome</th>
                            <th class="text-left">ISRC</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="track in tracks" :key="track.isrc">
                            <td>{{ track.pivot.track_number }} </td>
                            <td>{{ track.name }}</td>
                            <td>{{ track.isrc.toUpperCase() }}</td>                            
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
          
        </v-col>
    </v-row>
</template>
<style scoped>
.subtitle-2{
    padding-right: 5px;
}
</style>
<script>
import ProductService from "../../../app/Rest/product";
let productService = null;

//components
import modalmessage from "../../../components/shared/modalmessage";
export default {
    components: {
        modalmessage,
    },
    data: () => ({
        product: null,
        cover: null,
        tracks: null,
    }),
    computed: {
        computed_cover() {
            if (this.product.thumbnail) {
                return this.product.thumbnail.indexOf("googleapis") >= 0
                    ? this.product.thumbnail
                    : process.env.VUE_APP_BASE_URL + this.product.thumbnail;
            } else if (this.thumbnail != null) {
                return this.thumbnail;
            } else {
                return false;
            }
        },
    },
    beforeCreate: function () {
        productService = ProductService.build();

        if (this.$route.params)
            this.editable_product =
                this.$route.params.id == undefined
                    ? false
                    : this.$route.params.id;

        if (!this.editable_product) {
            return;
        }

        this.$store.dispatch("loading_full");
        productService
            .getOne(this.editable_product)
            .then((e) => {
                if (e.items) {
                    this.product = e.items.product;
                    this.cover = this.product.thumbnail;
                    this.tracks = e.items.tracks;
                } else {
                    this.$store.dispatch("loading_full", false);
                    this.$refs.modal.show({
                        title: "Não encontrado",
                        message: "O produto buscado não foi encontrado",
                        btn_1_text: "Entendi",
                        btn_1_action: () => {
                            this.$router.push({ name: "products" });
                        },
                    });
                }
            })
            .finally(() => {
                this.$store.dispatch("loading_full", false);
            });
    },
};
</script>